import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { ChangeEmailType, UserPreferenceType, VerifyEmailType } from '@/api/apis/user';
import { queryClient } from '@/queries';
import { userQueries } from '@/queries/user';
import { updateUserPreferencesInCache } from '@/queries/utils';

export const useResendUserInviteMutation = () => {
  return useMutation({
    mutationFn: (userId: string) => api.user.resendUserInvite(userId),
  });
};

export const updateUserPreferencesMutationKey = ['updateUserPreferences'];

export const useUpdateUserPreferencesMutation = () => {
  return useMutation({
    mutationKey: updateUserPreferencesMutationKey,
    mutationFn: (userPreferences: UserPreferenceType[]) => {
      return api.user.updateUserPreferences({ userPreferences });
    },
    onSuccess: (_, updatedPreferences) => {
      queryClient.setQueryData(userQueries.profile().queryKey, (cachedPreferences) => {
        if (!cachedPreferences) return cachedPreferences;

        return updateUserPreferencesInCache(cachedPreferences, updatedPreferences);
      });
    },
  });
};

export const useChangeEmailMutation = () => {
  return useMutation({
    mutationFn: (data: Partial<ChangeEmailType> & { userId: string }) => api.user.changeEmail(data),
  });
};

export const useVerifyEmailMutation = () => {
  return useMutation({
    mutationFn: (data: Partial<VerifyEmailType> & { userId: string }) => api.user.verifyEmail(data),
  });
};
